var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.859,
    height: 15.859,
    viewBox: "0 0 15.859 15.859",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-close",
    "data-name": "Icon material-close",
    d: "M23.359,9.1l-1.6-1.6L15.43,13.832,9.1,7.5,7.5,9.1l6.332,6.332L7.5,21.762l1.6,1.6,6.332-6.332,6.332,6.332,1.6-1.6L17.027,15.43Z",
    transform: "translate(-7.5 -7.5)",
    fill: "#122866"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.5a8b6909a3ba8f8effb05a0192b34f52.svg";
export { ForwardRef as ReactComponent };